module.exports = __webpack_public_path__ + "img/dl (10).3a7be8bf.jpg";